module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile",
    on: {
      "click": _vm.openAlbum
    }
  }, [_c('intrinsic', {
    attrs: {
      "small": _vm.src,
      "alt": _vm.alt,
      "ratio": "12x8",
      "fit": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile__description"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff8b749"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/custom/tile.vue
// module id = 179
// module chunks = 4